import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import { delay } from '../../../../services/global';
import { useModalReturn } from '../../../hooks/useModal';
import CustomModal from '../../global/CustomModal';

interface Props {
  isValid: boolean;
  modal: useModalReturn;
  value: any;
  currentMeasure: string;
  setValue: (value: any, shouldValidate?: boolean | undefined) => void;
  handleClick: (value: number, type: string, currentMeasure: string) => string | number;
  handleSubmit: (isDelete?: boolean) => void;
}

function DeleteItem({
  isValid,
  modal,
  value,
  currentMeasure,
  setValue,
  handleClick,
  handleSubmit,
}: Props) {
  const [showModal, setShowModal] = useState<boolean>(modal.show);

  const deleteItem = () => {
    if (isValid) {
      setValue(handleClick(value, 'delete', currentMeasure));
      delay(() => {
        handleSubmit(true);
      }, 500);
    }
  };

  useEffect(() => setShowModal(modal.show), [modal.show]);

  return (
    <>
      <CustomModal show={showModal} onHide={() => setShowModal(false)} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>Deseja excluir o item?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Após a confirmação, nenhuma alteração poderá ser desfeita.</Modal.Body>
        <Modal.Footer>
          <Button type="button" variant="secondary" className="mr-1" onClick={modal.onHide}>
            Cancelar
          </Button>
          <Button type="button" variant="danger" onClick={() => deleteItem()}>
            Excluir
          </Button>
        </Modal.Footer>
      </CustomModal>
    </>
  );
}

export default DeleteItem;
